import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { under30Plans, over30Plans } from "components/Pricing/constants";
import { PricingSegmentCard } from "components/Pricing/components/PricingSegmentCard";

export const Pricing = () => (
  <Box
    sx={{
      backgroundColor: "primary.dark",
      py: { xs: 8, sm: 12 },
      px: { xs: 3, sm: 6 },
      color: "common.white",
    }}
  >
    <Container
      id="pricing"
      maxWidth="lg"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: { xs: 3, sm: 4 },
      }}
    >
      {/* Header */}
      <Box sx={{ width: "100%", maxWidth: 900, textAlign: "center" }}>
        <Typography component="h2" variant="h4" sx={{ color: "common.white", fontWeight: 900 }}>
          Pricing
        </Typography>
        <Typography
          sx={{
            mt: 1,
            color: (theme) => alpha(theme.palette.common.white, 0.75),
            fontWeight: 500,
            fontSize: { xs: 15, sm: 17 },
          }}
        >
          Age-based pricing applies due to Danish VAT rules -{" "}
          <Link to="/faq" style={{ color: "inherit" }}>learn why</Link>.
        </Typography>
      </Box>

      {/* Memberships */}
      <Grid container spacing={3} justifyContent="center" sx={{ maxWidth: 1200 }}>
        <Grid item xs={12} md={6}>
          <PricingSegmentCard
            title="Under 30 years old"
            plans={under30Plans}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <PricingSegmentCard
            title="30+ years old"
            subtitle="Prices incl. 25% VAT"
            plans={over30Plans}
          />
        </Grid>
      </Grid>
    </Container>
  </Box>
);
